// Global packages and components
import { clsx } from 'clsx'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { Image } from '~/components'

// Types
import type { SanityCustomImage } from '~/types'

interface NavLinkInnerProps {
  icon?: SanityCustomImage
  title: string
  titleBold?: boolean
  titleHighlight?: boolean
  hasArrow?: boolean
  hasIcon?: boolean
}

// Main export
const LinkInner = ({
  icon,
  title,
  titleBold,
  titleHighlight,
  hasArrow,
  hasIcon,
}: NavLinkInnerProps) => (
  <div className="flex w-full items-center justify-between">
    <div className="flex w-full items-center">
      {hasIcon && icon?.asset && (
        <Image
          image={icon}
          customSize={150}
          className="mr-2 max-w-10"
        />
      )}
      <div
        className={clsx({
          'font-bold': titleBold,
          'text-red-600': titleHighlight,
        })}
      >
        {title}
      </div>
    </div>
    {hasArrow && <ChevronRightIcon className="ml-3 size-4" />}
  </div>
)

export default LinkInner
